import React from 'react'
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  LinearScale,
  Tooltip as ChartTooltip,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { Box, Typography } from '@mui/material'
import TileShell, { tileValueSx } from './TileShell'
import { breakdownChartData } from './tileColors'

ChartJS.register(CategoryScale, LinearScale, BarElement, ChartTooltip)

const BreakdownTile = ({ kpi }) => {
  const items = kpi.items ?? []
  const chart = breakdownChartData(items)
  const data = {
    labels: chart.labels,
    datasets: [
      {
        data: chart.values,
        backgroundColor: chart.colors,
        borderRadius: 4,
        maxBarThickness: 18,
      },
    ],
  }
  const options = {
    indexAxis: 'y',
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: {
      x: { beginAtZero: true, ticks: { precision: 0, maxTicksLimit: 5, font: { size: 10 } } },
      y: { grid: { display: false }, ticks: { font: { size: 10 } } },
    },
  }
  const height = Math.max(90, items.length * 24 + 24)

  return (
    <TileShell label={kpi.label} description={kpi.description} wide>
      {items.length ? (
        <Box width="100%" height={height}>
          <Bar data={data} options={options} />
        </Box>
      ) : (
        <Typography sx={{ ...tileValueSx, color: 'text.disabled' }}>N/A</Typography>
      )}
    </TileShell>
  )
}

export default BreakdownTile
